import React from 'react';
import { NavigationCartSmall } from '@strava/icons'; // TODO: [fumba] - use student plan icon
import styles from './styles.scss';

const Footnote = () => (
  <div className={styles.container} data-testid="footer">
    <div className={`text-footnote ${styles.row}`}>
      <div className={styles.icon}>
        <NavigationCartSmall />
      </div>
      <p>
        {`In a year, we'll remind you to reverify as a student to keep your
          discount` /* TODO: [fumba] copy  */}
      </p>
    </div>
  </div>
);

export default Footnote;
